export default __webpack_public_path__ + "static/artifakt-element-italic-252ab5a6da7387b58cddce93cfcdd4e8.eot";